import { Breadcrumb } from 'antd';
import { NavLink } from 'react-router-dom';

const BreadcrumbList = ({
  listBreadcrumb
}: {
  listBreadcrumb: { tittle: string; url: string }[];
}) => {
  return (
    <Breadcrumb separator=">" className="breadscrump">
      {(listBreadcrumb || []).map((item, index: number) => (
        <Breadcrumb.Item key={index}>
          {!item?.url || item?.url == '' ? (
            <a>
              <strong>{item.tittle}</strong>
            </a>
          ) : (
            <NavLink to={item?.url ?? ''}>
              <strong>{item.tittle}</strong>
            </NavLink>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
export default BreadcrumbList;
